import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=10c08f50&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=10c08f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c08f50",
  null
  
)

export default component.exports